import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { Appointment } from '../appointment/appointment';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};


@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  private appointmentsUrl = 'api/appointments';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) { }

  getAppointments(): Observable<Appointment[]> {
    return this.http
      .get<Appointment[]>(this.appointmentsUrl)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  getAppointment(id: number): Observable<Appointment> {
    return this.http
      .get<Appointment>(`${this.appointmentsUrl}/${id}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  getLastByPatient(patientId: number): Observable<Appointment> {
    return this.http
      .get<Appointment>(`${this.appointmentsUrl}/last/?patientId=${patientId}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  searchAppointmentByPatientId(patientId: number): Observable<Appointment[]> {
    if (patientId < 1) { return of([]); }
    return this.http
      .get<Appointment[]>(`${this.appointmentsUrl}/?patientId=${patientId}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  createAppointment(appointment: Appointment): Observable<Appointment> {
    return this.http
      .post<Appointment>(this.appointmentsUrl, appointment, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  updateAppointment(appointment: Appointment): Observable<Appointment> {
    return this.http
      .patch<Appointment>(`${this.appointmentsUrl}/${appointment.id}`, appointment, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
